"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfToJSON = exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSONTyped = exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSON(json) {
    return ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSON = ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSON;
function ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'addressOptions': !(0, runtime_1.exists)(json, 'addressOptions') ? undefined : (json['addressOptions'].map(_1.AddressOnlyFromJSON)),
    };
}
exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSONTyped = ChangeCustomerResultWithAddressBookAndOptionsAllOfFromJSONTyped;
function ChangeCustomerResultWithAddressBookAndOptionsAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'addressOptions': value.addressOptions === undefined ? undefined : (value.addressOptions.map(_1.AddressOnlyToJSON)),
    };
}
exports.ChangeCustomerResultWithAddressBookAndOptionsAllOfToJSON = ChangeCustomerResultWithAddressBookAndOptionsAllOfToJSON;
//# sourceMappingURL=ChangeCustomerResultWithAddressBookAndOptionsAllOf.js.map